import constants from 'constants/index'

const getDataCategories = (collectedFields) => {
  const categories = []

  if (collectedFields) {
    collectedFields.forEach((field) => {
      const type = Number(field.dataCollectedOption?.dataType)
      const label = constants.dataCollected.DATA_TYPE_LABELS[type] || 'Outros'
      categories.push(label)
    })
  }

  return categories
    .filter((item, index) => categories.indexOf(item) === index)
    .join(', ')
}

export default getDataCategories
